import _ from 'lodash'
import { IProviderDetails } from '../definitions/Providers'

class QualityMeasureManagerClass {
    worst = (measures: IProviderDetails['qualityMeasures']) => {
        return _.maxBy(measures, x => this.topBand(x)?.gainPercentage - (this.currentBand(x)?.gainPercentage ?? 0))
    }

    currentBand = (qm: IProviderDetails['qualityMeasures'][0]) => qm.scoringBands.find(x => x.isActive)
    topBand = (qm: IProviderDetails['qualityMeasures'][0]) => _.maxBy(qm.scoringBands, x => x.min)
}

const QualityMeasureManager = new QualityMeasureManagerClass()
export default QualityMeasureManager
